export default "__VITE_ASSET__87b64ae2__"